import { useState, useEffect } from 'react';
import { AuthService, AuthState, User } from './auth';

export const useAuth = () => {
  const authService = AuthService.getInstance();
  const [authState, setAuthState] = useState<AuthState>(authService.getAuthState());

  useEffect(() => {
    // Subscribe to auth state changes
    const unsubscribe = authService.subscribe(setAuthState);
    
    // Check if we need to refresh auth on mount
    if (authState.isAuthenticated) {
      authService.refreshAuth();
    }

    return unsubscribe;
  }, []);

  const login = async (email: string, password: string) => {
    return authService.login(email, password);
  };

  const register = async (email: string, password: string, name?: string, accessCode?: string) => {
    return authService.register(email, password, name, accessCode);
  };

  const logout = () => {
    authService.logout();
  };

  return {
    user: authState.user,
    isAuthenticated: authState.isAuthenticated,
    isLoading: authState.isLoading,
    login,
    register,
    logout,
  };
}; 